import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// A patient's medication & vaccination history over a recent look-back window
// (12 months): active (prescribed) + discontinued medications — both ACUTE and
// LONGTERM — plus vaccinations. Returns PatientMedicationHistoryDTO
// ({ windowMonths, from, prescribed[], discontinued[], vaccinations[] }).
// Read-only reference on the antenatal consultation (KIN-1085); the BE compiles
// the actual MN-CMS Medication field, so this is never submitted.
export const usePatientMedicationHistory = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["patientMedicationHistory", patientId, tenantVal],
    queryFn: async () => {
      const axios = createAxiosInstance();
      const response = await axios.get(
        `${tenantVal}/patientmedication/history/${patientId}`
      );

      return response.data?.data ?? response.data;
    },
    enabled: !!patientId && !!tenantVal,
  });
};
